export default "<div class=\"container-box\">\n  <img [src]=\"imagem\" alt=\"\">\n  <br><br>\n  <h2>{{ titulo }}</h2>\n  <p>{{mensagem}}</p>\n</div>\n";